import React from 'react'
import {Modal,Form,Button,Input,message,Checkbox,Row,Col} from 'antd'
import moment from 'moment'
import axios from 'axios'
import Utils from "src/js/utils";

class AntdForm extends React.Component{
    constructor(props){
        super(props)
        this.state={
           
        }
    }
    handlePass(){
        Modal.confirm({
            content:`点击“确定”后，本条数据将通过审核!`,
            okText:'确定',
            cancelText:'取消',
            onOk:()=>{
                //请求通过
                var sendData={
                    assetstype:11,
                    id:this.props.modalData.id,
                    authState:1,
                    auth_time:moment().format('YYYY/MM/DD HH:mm:ss'),
                }
               

                axios.post('/api/admin/review/assets',sendData).then(res=>{
                    if(res.data.error===null){
                        message.success('已通过!')
                        this.props.cancelShowInfo();
                        this.props.refreshList()
                    }
                })
              
            }
        })
        //通过
       
    }
    handleReject(){
        Modal.confirm({
            content:<div>
                <div>请输入驳回原因：</div>
                <Input.TextArea rows={4} className='minput'></Input.TextArea>
            </div>,
            okText:'确定',
            cancelText:'取消',
            onOk:()=>{
                var str=document.querySelector('.minput').value
                var sendData={
                    id:this.props.modalData.id,
                    assetstype:11,
                    authState:2,
                    auth_time:moment().format('YYYY/MM/DD HH:mm:ss'),
                    auth_comment:str
                }
               
                axios.post('/api/admin/review/assets',sendData).then(res=>{
                    if(res.data.error===null){
                        message.success('已驳回！')
                        this.props.cancelShowInfo()
                        this.props.refreshList()
                    }
                })
               
            },
          
        })
        //拒绝
    }
   
    render(){
        let {modalData}=this.props;
        modalData=Utils.convertToArray(modalData);
        console.log("tyoe:"+typeof(modalData.body_size));
        
        console.log("bodysize:"+modalData.body_size);
        
        const formItemLayout = {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 6 },
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 18 },
            },
          };
      
        return (
            <div>
                <div>
                    <div className='modalTitle'>Taxonomy Functional Traits</div>
                    <div className='form'>
                        <Form {...formItemLayout}>
                           
                            <Form.Item label='ID'>
                                <span>{modalData.id}</span>
                            </Form.Item>
                            <Form.Item label='Taxonomy ID'>
                                <span>{modalData.taxonmixed_id}</span>
                            </Form.Item>

                            <Form.Item label='Reference'>
                                    <span>{modalData.reference}</span>
                            </Form.Item>
                        
                            <Form.Item  label={<p>Body size</p>}>
                            <span>                           
                                {
                                    <Checkbox.Group disabled style={{width:'100%'}} defaultValue={modalData.body_size}>
                                        <Row>
                                        <Col span={5}>
                                            <Checkbox value="Large">Large ({`>`}20mm)</Checkbox>
                                        </Col>
                                        <Col span={6}>
                                            <Checkbox value="Medium">Medium (5-20mm)</Checkbox>
                                        </Col>
                                        <Col span={5}>
                                            <Checkbox value="Small">Small (0.5-5mm)</Checkbox>
                                        </Col>
                                        <Col span={5}>
                                            <Checkbox value="Micro">Micro ({`<`}0.5mm)</Checkbox>
                                        </Col>
                                        </Row>
                                    </Checkbox.Group>
                                }
                                </span>
                            </Form.Item>

                            <Form.Item  label={<p>Feeding mode</p>}>
                            <span> 
                                    <Checkbox.Group disabled style={{width:'100%'}} defaultValue={modalData.feeding_mode}>
                                        <Row>
                                            <Col span={6}>
                                                <Checkbox value="Filter/suspension">Filter/suspension</Checkbox>
                                            </Col>
                                            <Col span={5}>
                                                <Checkbox value="Grazer/scraper">Grazer/scraper</Checkbox>
                                            </Col>
                                            <Col span={5}>
                                                <Checkbox value="Omnivore">Omnivore</Checkbox>
                                            </Col>
                                            <Col span={5}>
                                                <Checkbox value="Predator">Predator</Checkbox>
                                            </Col>
                                            <Col span={7}>
                                                <Checkbox value="Scavenger/opportunist">Scavenger/opportunist</Checkbox>
                                            </Col>
                                            <Col span={8}>
                                                <Checkbox value="Sub-surface_deposit_feeder">Sub-surface deposit feeder</Checkbox>
                                            </Col>
                                            <Col span={5}>
                                                <Checkbox value="Other">Other</Checkbox>
                                            </Col>
                                        </Row>
                                    </Checkbox.Group>
                                </span>
                            </Form.Item>

                            <Form.Item  label={<p>Mobility</p>}>
                            <span>
                                <Checkbox.Group disabled style={{width:'100%'}} defaultValue={modalData.mobility}>
                                    <Row>
                                    <Col span={4}>
                                        <Checkbox value="Freely/fast">Freely/fast</Checkbox>
                                    </Col>
                                    <Col span={4}>
                                        <Checkbox value="Freely/slow">Freely/slow</Checkbox>
                                    </Col>
                                    <Col span={7}>
                                        <Checkbox value="Facultative/unattached">Facultative/unattached</Checkbox>
                                    </Col>
                                    <Col span={6}>
                                        <Checkbox value="Facultative/attached">Facultative/attached</Checkbox>
                                    </Col>
                                    <Col span={7}>
                                        <Checkbox value="Non-motile/unattached">Non-motile/unattached</Checkbox>
                                    </Col>
                                    <Col span={7}>
                                        <Checkbox value="Non-motile/attached">Non-motile/attached</Checkbox>
                                    </Col>
                                    </Row>
                                </Checkbox.Group>
                            </span>
                            </Form.Item>

                            <Form.Item  label={<p>Morphology</p>}>
                                <span>
                                    <Checkbox.Group disabled style={{width:'100%'}} defaultValue={modalData.morphology}>
                                        <Row>
                                            <Col span={4}>
                                                <Checkbox value="Irregular">Irregular</Checkbox>
                                            </Col>
                                            <Col span={6}>
                                                <Checkbox value="Round/Globulose">Round/Globulose</Checkbox>
                                            </Col>
                                            <Col span={5}>
                                                <Checkbox value="Streamlined">Streamlined</Checkbox>
                                            </Col>
                                            <Col span={5}>
                                                <Checkbox value="Vermiform">Vermiform</Checkbox>
                                            </Col>
                                        </Row>
                                    </Checkbox.Group>
                                </span>
                            </Form.Item>

                            <Form.Item  label={<p>Tiering</p>}>
                                <span>
                                    <Checkbox.Group disabled style={{width:'100%'}} defaultValue={modalData.tiering}>
                                        <Row>
                                        <Col span={4}>
                                            <Checkbox value="Pelagic">Pelagic</Checkbox>
                                        </Col>
                                        <Col span={4}>
                                            <Checkbox value="Erect">Erect</Checkbox>
                                        </Col>
                                        <Col span={4}>
                                            <Checkbox value="Surficial">Surficial</Checkbox>
                                        </Col>
                                        <Col span={5}>
                                            <Checkbox value="Semi-infaunal">Semi-infaunal</Checkbox>
                                        </Col>
                                        <Col span={6}>
                                            <Checkbox value="Shallow_infaunal">Shallow infaunal</Checkbox>
                                        </Col>
                                        <Col span={5}>
                                            <Checkbox value="Deep_infaunal">Deep infaunal</Checkbox>
                                        </Col>
                                        </Row>
                                    </Checkbox.Group>
                                </span>
                            </Form.Item>

                            <Form.Item  label={<p>Rigidity</p>}>
                                <span>
                                    <Checkbox.Group disabled style={{width:'100%'}} defaultValue={modalData.rigidity}>
                                        <Row>
                                            <Col span={6}>
                                                <Checkbox value="Hard_exoskeleton">Hard exoskeleton</Checkbox>
                                            </Col>
                                            <Col span={4}>
                                                <Checkbox value="Hard_shell">Hard shell</Checkbox>
                                            </Col>
                                            <Col span={6}>
                                                <Checkbox value="Rigid/Rigid_tubes">Rigid/Rigid tubes</Checkbox>
                                            </Col>
                                            <Col span={6}>
                                                <Checkbox value="Soft/Fragile">Soft/Fragile</Checkbox>
                                            </Col>
                                        </Row>
                                    </Checkbox.Group>
                                </span>
                            </Form.Item>

                            <Form.Item  label={<p>Reproduction</p>}>
                                <span>
                                    <Checkbox.Group disabled style={{width:'100%'}} defaultValue={modalData.reproduction}>
                                        <Row>
                                            <Col span={5}>
                                                <Checkbox value="Asexual">Asexual</Checkbox>
                                            </Col>
                                            <Col span={5}>
                                                <Checkbox value="Sexual">Sexual</Checkbox>
                                            </Col>
                                        </Row>
                                    </Checkbox.Group>
                                </span>
                            </Form.Item>

                            <Form.Item  label={<p>Growth form</p>}>
                                <span>
                                    <Checkbox.Group disabled style={{width:'100%'}} defaultValue={modalData.growth_form}>
                                        <Row>
                                            <Col span={4}>
                                                <Checkbox value="Solitary">Solitary</Checkbox>
                                            </Col>
                                            <Col span={10}>
                                                <Checkbox value="Multiserial_modularity/coloniality">Multiserial modularity/coloniality</Checkbox>
                                            </Col>
                                        </Row>
                                    </Checkbox.Group>
                                </span>
                            </Form.Item>

                            <Form.Item  label={<p>Structural fragility</p>}>
                                <span>
                                    <Checkbox.Group disabled style={{width:'100%'}} defaultValue={modalData.structural_fragility}>
                                        <Row>
                                            <Col span={9 }>
                                                <Checkbox value="Very_fragile/Highly_breakable">Very fragile/Highly breakable</Checkbox>
                                            </Col>
                                            <Col span={9}>
                                                <Checkbox value="Fragile/Limited_flexibility">Fragile/Limited flexibility</Checkbox>
                                            </Col>
                                            <Col span={9}>
                                                <Checkbox value="Very_strong/Extremely_flexible">Very strong/Extremely flexible</Checkbox>
                                            </Col>
                                        </Row>
                                    </Checkbox.Group>
                                </span>
                            </Form.Item>

                            <Form.Item  label={<p>Larval type</p>}>
                                <span>
                                    <Checkbox.Group disabled style={{width:'100%'}} defaultValue={modalData.larval_type}>
                                        <Row>
                                            <Col span={7}>
                                                <Checkbox value="Pelagic_planktotrophic">Pelagic planktotrophic</Checkbox>
                                            </Col>
                                            <Col span={6}>
                                                <Checkbox value="Pelagic_lecthrotophic">Pelagic lecthrotophic</Checkbox>
                                            </Col>
                                            <Col span={3}>
                                                <Checkbox value="Benthic">Benthic</Checkbox>
                                            </Col>
                                            <Col span={8}>
                                                <Checkbox value="Brooder/Direct_developer">Brooder/Direct developer</Checkbox>
                                            </Col>
                                            <Col span={5}>
                                                <Checkbox value="No_larvae">No larvae</Checkbox>
                                            </Col>
                                        </Row>
                                    </Checkbox.Group>
                                </span>
                            </Form.Item>

                            <Form.Item  label={<p>Trophic level</p>}>
                                <span>
                                    <Checkbox.Group disabled style={{width:'100%'}} defaultValue={modalData.trophic_level}>
                                        <Row>
                                            <Col span={5}>
                                                <Checkbox value="Producer">Producer</Checkbox>
                                            </Col>
                                            <Col span={5}>
                                                <Checkbox value="consumer">consumer</Checkbox>
                                            </Col>
                                            <Col span={5}>
                                                <Checkbox value="Other">Other</Checkbox>
                                            </Col>
                                        </Row>
                                    </Checkbox.Group>
                                </span>
                            </Form.Item>

                            <Form.Item  label={<p>Sediment stabiliser</p>}>
                                <span>
                                    <Checkbox.Group disabled style={{width:'100%'}} defaultValue={modalData.sediment_stabiliser}>
                                        <Row>
                                            <Col span={5}>
                                                <Checkbox value="Destabiliser">Destabiliser</Checkbox>
                                            </Col>
                                            <Col span={5}>
                                                <Checkbox value="None">None</Checkbox>
                                            </Col>
                                            <Col span={5}>
                                                <Checkbox value="Stabiliser">Stabiliser</Checkbox>
                                            </Col>
                                        </Row>
                                    </Checkbox.Group>
                                </span>
                            </Form.Item>
                        </Form>

                        <div className='foot'>
                            <Button  type='agbdb1' onClick={()=>{this.handlePass()}}>通过</Button>
                            <Button  type='agbdb2' onClick={()=>{this.handleReject()}}>拒绝</Button>
                        </div>
                    </div>
                </div>
        </div>
        )
      
    }
}
const AUserInfoModal = Form.create()(AntdForm);
export default AUserInfoModal